var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.$functions.parseBase64ToImage(_vm.image),"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }